/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */
export const GET_FRONTPAGESLIDES = 'GET_FRONTPAGESLIDES';
export const GET_DEFAULT_HEADER_IMAGE = 'GET_DEFAULT_HEADER_IMAGE';
export const SET_FOLDER_HEADER = 'SET_FOLDER_HEADER';
export const SET_FOLDER_TABS = 'SET_FOLDER_TABS';
export const GET_PARENT_FOLDER_DATA = 'GET_PARENT_FOLDER_DATA';
export const GET_MOSAIC_SETTINGS = 'GET_MOSAIC_SETTINGS';
// export const GET_DATA_PROVIDERS = 'GET_DATA_PROVIDERS';
export const GET_LOCALNAVIGATION = 'GET_LOCALNAVIGATION';
export const GET_CHART_DATA_FROM_VISUALIZATION =
  'GET_CHART_DATA_FROM_VISUALIZATION';
// NEWS
export const GET_NEWS = 'GET_NEWS';
export const SET_CURRENT_VERSION = 'SET_CURRENT_VERSION';
export const LINK_INTEGRITY_CHECK = 'LINK_INTEGRITY_CHECK';

export const GET_INDEX_VALUES = 'GET_INDEX_VALUES';
export const GET_CONTROLPANEL_FALLBACKS = 'GET_CONTROLPANEL_FALLBACKS';

export const CREATE_ATTACHMENT = 'CREATE_ATTACHMENT';
export const GET_ALL_ATTACHMENTS = 'GET_ALL_ATTACHMENTS';
export const GET_ATTACHMENTS = 'GET_ATTACHMENTS';
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT';
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT';

export const GET_PORTLETS = 'GET_PORTLETS';
export const FORCE_DRAFT_EDITOR_REFRESH = 'FORCE_DRAFT_EDITOR_REFRESH';

export const CHANGE_SIDEBAR_STATE = 'CHANGE_SIDEBAR_STATE';
export const CLONE_AS_TYPE = 'CLONE_AS_TYPE';

export const CHANGE_MAP_DATA = 'CHANGE_MAP_DATA';

export const GET_MAP_DATA = 'GET_MAP_DATA';
export const QUICK_RESET_SEARCH_CONTENT = 'QUICK_RESET_SEARCH_CONTENT';
export const QUICK_SEARCH_CONTENT = 'QUICK_SEARCH_CONTENT';

export const GET_RESOURCES = 'GET_RESOURCES';
